import { useState } from "react"
import { keepPreviousData, useMutation, UseMutationOptions, useQuery } from "@tanstack/react-query"
import { deleteTreatmentCaseHelpfulClient, getTreatmentCaseSummaryListClient, postTreatmentCaseHelpfulClient } from "@/entities/treatment-case/api/treatment-case.client"
import { TreatmentCaseSummaryResponse } from "@/shared/types/type/treatment"
import { ApiResponse } from "@/shared/types/interface/api"

export const useQueryTreatmentCaseSummaryList = (
  categoryId: number,
  initialData?: TreatmentCaseSummaryResponse[]
) => {
  const [initialCategoryId] = useState(categoryId)

  return useQuery<ApiResponse<TreatmentCaseSummaryResponse[]>, Error, TreatmentCaseSummaryResponse[]>({
    queryKey: ["treatmentCaseSummaryList", categoryId],
    queryFn: () => getTreatmentCaseSummaryListClient(categoryId),
    select: (data) => data.result,
    initialData:
      initialData && categoryId === initialCategoryId
        ? { status: 200, message: "", result: initialData }
        : undefined,
    placeholderData: keepPreviousData,
  })
}

export const useMutationTreatmentCaseHelpful = (options?: UseMutationOptions<unknown, Error, number, unknown>) => {
  return useMutation<unknown, Error, number>({
    mutationFn: postTreatmentCaseHelpfulClient,
    ...options,
  })
}

export const useMutationTreatmentCaseHelpfulDelete = (options?: UseMutationOptions<unknown, Error, number, unknown>) => {
  return useMutation<unknown, Error, number>({
    mutationFn: deleteTreatmentCaseHelpfulClient,
    ...options,
  })
}
